import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { WORK_CALENDAR } from '../types/work-calendar.js';
import { WORK_SHIFT } from '../types/work-shift.js';
import { WORK_CALENDAR_EXCEPTION } from '../types/work-calendar-exception.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for WorkCalendar (jornada / work calendar).
 * Stored in 'org/{orgId}/work-calendar'.
 * Shifts and exceptions live in subcollections (spec 0042 §2.1 / request 0189).
 */
export const workCalendarDescriptor = {
    name: WORK_CALENDAR,
    label: 'Calendário de trabalho',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/work-calendar',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Named work calendar (jornada). Shifts and day exceptions live in subcollections.',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique work calendar identifier',
        },
        {
            name: 'code',
            example: 1,
            label: 'Código',
            type: 'number',
            display: 'code',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric catalog code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Calendário Tinturaria',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Calendar description (e.g. Padrão 2 turnos)',
        },
        {
            name: 'dayStartMinuteOfDay',
            example: 420,
            label: 'Início do dia operacional',
            type: 'number',
            display: 'code',
            required: true,
            description: 'Wall-clock minute (0..1439) at which the journey rolls to the next operational day. Default 0.',
        },
        {
            name: 'notes',
            example: 'Turno 1 — 07:00 às 15:20',
            label: 'Observações',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.NOTES,
            description: 'Free-text notes',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'id',
            targetEntity: WORK_SHIFT,
            relationship: 'one-to-many',
            description: 'Turnos do calendário',
        },
        {
            fieldName: 'id',
            targetEntity: WORK_CALENDAR_EXCEPTION,
            relationship: 'one-to-many',
            description: 'Exceções (feriados / dias extras) do calendário',
        },
    ],
};
//# sourceMappingURL=work-calendar.descriptor.js.map